import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CheckDeposit\StoreCheckDepositController::__invoke
* @see app/Http/Controllers/CheckDeposit/StoreCheckDepositController.php
* @route '/api/check-deposit'
*/
const StoreCheckDepositController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreCheckDepositController.url(options),
    method: 'post',
})

StoreCheckDepositController.definition = {
    methods: ["post"],
    url: '/api/check-deposit',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CheckDeposit\StoreCheckDepositController::__invoke
* @see app/Http/Controllers/CheckDeposit/StoreCheckDepositController.php
* @route '/api/check-deposit'
*/
StoreCheckDepositController.url = (options?: RouteQueryOptions) => {
    return StoreCheckDepositController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckDeposit\StoreCheckDepositController::__invoke
* @see app/Http/Controllers/CheckDeposit/StoreCheckDepositController.php
* @route '/api/check-deposit'
*/
StoreCheckDepositController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreCheckDepositController.url(options),
    method: 'post',
})

export default StoreCheckDepositController